import { listPaperLogs } from '../../core/apis'
import { useQuery } from 'react-query'
import FlexBlock from '../FlexBlock'
import { Spinner } from 'baseui/spinner'
import React from 'react'
import { Table } from 'baseui/table-semantic'
import spacetime from 'spacetime'

export default function LogList({ id }) {
	const { data, isLoading } = useQuery(['logs', { id }], listPaperLogs)
	const { results } = data || {}

	if (isLoading) {
		return (
			<FlexBlock justifyContent="center" alignItems="center" width="100%" height="500px">
				<Spinner $size="50px" $borderWidth="5px" $color="#000" />
			</FlexBlock>
		)
	}

	function parseDatetime(strDatetime) {
		return spacetime(strDatetime).unixFmt('YYYY.MM.dd HH:mm')
	}

	return (
		<FlexBlock width="100%" id="table-log">
			<Table
				columns={['사용자', '내용', '일자']}
				data={results.map((row) => [row.user.name || '자동생성', row.message, parseDatetime(row.created_datetime)])}
				overrides={{
					Root: {
						style: {
							width: '100%',
						},
					},
					TableBodyCell: {
						style: {
							fontSize: '14px',
							wordBreak: 'keep-all',
							'@media screen and (max-width: 768px)': {
								fontSize: '12px',
							},
						},
					},
					TableHeadCell: {
						style: {
							fontSize: '14px',
							'@media screen and (max-width: 768px)': {
								fontSize: '12px',
							},
						},
					},
				}}
			/>
		</FlexBlock>
	)
}
